(() => {
  'use strict';

  const fallbackFlag = '__life100StampCollectionFallbackV1';
  if (window[fallbackFlag]) return;
  window[fallbackFlag] = true;

  let fallbackRequired;

  const needsFallback = () => {
    if (typeof fallbackRequired === 'boolean') return fallbackRequired;

    const stampCustomScript = Array.from(document.scripts).find((script) => {
      const source = script.textContent || '';
      return source.includes('Stamp - Variant Collections custom js error:')
        && source.includes('sezerium:variant:initialize');
    });

    // Do not cache this case: the app block may not have been parsed yet.
    if (!stampCustomScript) return true;

    const source = stampCustomScript.textContent || '';
    fallbackRequired = source.includes('sliders.forEach((sliderSlide) => {')
      && source.includes('                break;');

    return fallbackRequired;
  };

  document.addEventListener('sezerium:variant:initialize', (event) => {
    if (!needsFallback()) return;

    const { el, variant } = event.detail;

    if (variant.image) {
      const block = el?.matches?.('product-block') ? el : el?.querySelector?.('product-block');
      if (!block) return;

      if (!block.images || block.images.length === 0) {
        block.init?.();
        block.lazyLoadAll?.();
      }

      const sliders = block.querySelectorAll('.product-block__image');

      for (const sliderSlide of sliders) {
        const img = sliderSlide.querySelector('img');
        if (img && img.src && img.src.includes(variant.image)) {
          sliderSlide.classList.add('product-block__image--active');
          img.classList.add('sezerium-image');
          const imageIndex = sliderSlide.getAttribute('data-image-index') || 0;
          block.setActiveImage?.(parseInt(imageIndex, 10));

          event.detail.product.imagesTmp = event.detail.product.images;
          event.detail.variant.imageTmp = event.detail.variant.image;
          event.detail.product.images = [];
          event.detail.variant.image = '';

          break;
        }
      }
    }
  });

  document.addEventListener('sezerium:set:productCount', (event) => {
    if (!needsFallback()) return;

    const { productCount } = event.detail;
    const productCountDiv = document.querySelector('.utility-bar__centre > .utility-bar__item');

    if (productCountDiv) {
      productCountDiv.textContent = productCountDiv.textContent.replace(/[0-9]+/, productCount);
    }
  });

  document.addEventListener('sezerium:price:update', (event) => {
    if (!needsFallback()) return;

    const { el } = event.detail;
    const priceFrom = el.querySelector('.price__from');

    if (priceFrom) priceFrom.remove();
  });

  document.addEventListener('sezerium:swatch:update', (event) => {
    if (!needsFallback()) return;

    const { el, variant } = event.detail;

    setTimeout(() => {
      const swatch = el.querySelector(
        `.product-block-options__item[data-option-item="${variant.option1}"]`
      );

      if (swatch) {
        const parent = swatch.closest('fieldset') ?? swatch.parentNode;
        parent.classList.add('sezerium-swatch');
        swatch.dispatchEvent(new Event('mouseenter', { bubbles: true }));
      }
    }, 250);
  });
})();
